"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _Label = _interopRequireDefault(require("../../component/Label"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var triggerSyntheticClick = function triggerSyntheticClick(e) {
  e.preventDefault();
  e.stopPropagation();
  e.currentTarget.childNodes.forEach(function (node) {
    if (node instanceof HTMLElement) {
      node.click();
    }
  });
};

var withLabel = function withLabel(Component) {
  return /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(WithLabel, _React$Component);

    var _super = _createSuper(WithLabel);

    function WithLabel() {
      (0, _classCallCheck2["default"])(this, WithLabel);
      return _super.apply(this, arguments);
    }

    (0, _createClass2["default"])(WithLabel, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            className = _this$props.className,
            wrappedClassName = _this$props.wrappedClassName,
            label = _this$props.label,
            _this$props$position = _this$props.position,
            position = _this$props$position === void 0 ? 'right' : _this$props$position,
            syntheticClick = _this$props.syntheticClick,
            disabled = _this$props.disabled,
            rest = (0, _objectWithoutProperties2["default"])(_this$props, ["className", "wrappedClassName", "label", "position", "syntheticClick", "disabled"]);
        return /*#__PURE__*/React.createElement(_Label["default"], {
          className: className,
          disabled: disabled,
          onClick: syntheticClick ? triggerSyntheticClick : undefined
        }, position === 'right' && label, /*#__PURE__*/React.createElement(Component, (0, _extends2["default"])({}, rest, {
          className: wrappedClassName,
          disabled: disabled
        })), position === 'left' && label);
      }
    }]);
    return WithLabel;
  }(React.Component);
};

exports["default"] = withLabel;
//# sourceMappingURL=index.js.map